if (!customElements.get('filament-quantity-offer')) {
  customElements.define('filament-quantity-offer', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe?.();
      this.coupon = this.querySelector('.cart-filament-tiers');
      this.onPointerMove = event => {
        if (event.pointerType === 'touch' || this.coupon?.dataset.hoverGlow !== 'true') return;
        const rect = this.coupon.getBoundingClientRect();
        this.coupon.style.setProperty('--cart-glow-x', `${event.clientX - rect.left}px`);
        this.coupon.style.setProperty('--cart-glow-y', `${event.clientY - rect.top}px`);
        this.coupon.style.setProperty('--cart-glow-opacity', '1');
      };
      this.onPointerLeave = () => this.coupon?.style.setProperty('--cart-glow-opacity', '0');
      this.coupon?.addEventListener('pointermove', this.onPointerMove);
      this.coupon?.addEventListener('pointerleave', this.onPointerLeave);
      if (typeof theme === 'undefined' || !theme.pubsub) return;
      this.unsubscribe = theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, event => {
        const cart = event?.cart;
        if (!Array.isArray(cart?.items) || cart.errors || cart.status >= 400) return;
        const count = cart.items.reduce((total, item) => total + (
          String(item.product_type || '').toLowerCase().includes('filament')
            ? Math.max(0, Number(item.quantity) || 0) : 0
        ), 0);
        this.update(count, cart);
      });
    }

    update(count, cart) {
      const tiers = [...this.querySelectorAll('[data-threshold]')];
      const status = this.querySelector('.a2l-filament-offer__status');
      if (!tiers.length || !status) return;
      const current = tiers.filter(tier => count >= Number(tier.dataset.threshold)).at(-1);
      const next = tiers.find(tier => count < Number(tier.dataset.threshold));
      this.dataset.count = count;
      this.coupon?.style.setProperty('--tier-progress', `${Math.max(0, tiers.indexOf(current)) / Math.max(1, tiers.length - 1) * 100}%`);
      const badge = this.querySelector('[data-filament-count]');
      if (badge) badge.textContent = `${count} ${count === 1 ? 'rollo' : 'rollos'} en carrito`;
      tiers.forEach(tier => {
        tier.toggleAttribute('data-achieved', count >= Number(tier.dataset.threshold));
        if (tier === current) tier.setAttribute('aria-current', 'step');
        else tier.removeAttribute('aria-current');
      });
      if (this.dataset.savingsMode === 'filament') {
        status.removeAttribute('title');
        if (Array.isArray(cart?.items)) {
          const items = cart.items.filter(item => String(item.product_type || item.type || '').toLowerCase().includes('filament'));
          const saved = items.reduce((total, item) => {
            const allocations = Array.isArray(item.discount_allocations) ? item.discount_allocations : item.discounts || [];
            return total + allocations.reduce((sum, allocation) => sum + Math.max(0, Number(allocation.amount) || 0), 0);
          }, 0);
          const currency = cart.currency || this.dataset.currency;
          const money = cents => `${new Intl.NumberFormat('es-MX', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100)} ${currency}`;
          this.dataset.currency = currency;
          const savings = this.querySelector('[data-filament-saved]');
          if (savings) savings.textContent = money(saved);
          const pricesKnown = items.every(item => typeof item.original_line_price === 'number' && item.original_line_price >= 0);
          const originalTotal = items.reduce((total, item) => total + (Number(item.original_line_price) || 0), 0);
          if (next && count > 0 && pricesKnown && originalTotal > 0) {
            const estimate = Math.max(0, Math.round(originalTotal / count * Number(next.dataset.threshold) * Number(next.dataset.discount) / 100) - saved);
            if (estimate > 0) {
              const remaining = Number(next.dataset.threshold) - count;
              status.textContent = `Agrega ${remaining} ${remaining === 1 ? 'rollo' : 'rollos'} más y ahorra aprox. ${money(estimate)} adicionales.`;
              status.title = 'Estimado según el precio promedio de los filamentos actuales. El ahorro final se confirma en el carrito.';
              return;
            }
          }
        }
        if (next) {
          const remaining = Number(next.dataset.threshold) - count;
          status.textContent = `Agrega ${remaining} ${remaining === 1 ? 'rollo' : 'rollos'}${count > 0 ? ' más' : ''} y obtén ${next.dataset.discount}% OFF.`;
          return;
        }
      }
      if (!next) {
        status.textContent = `¡Alcanzaste el ${current.dataset.discount}% OFF en filamentos!`;
        return;
      }
      const remaining = Number(next.dataset.threshold) - count;
      const rolls = remaining === 1 ? 'rollo' : 'rollos';
      status.textContent = current
        ? `Tienes ${current.dataset.discount}% OFF. Agrega ${remaining} ${rolls} más para llegar al ${next.dataset.discount}%.`
        : count === 0
          ? `Agrega ${remaining} ${rolls} y obtén ${next.dataset.discount}% OFF.`
          : `Agrega ${remaining} ${rolls} más para obtener ${next.dataset.discount}% OFF.`;
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      this.unsubscribe = null;
      this.coupon?.removeEventListener('pointermove', this.onPointerMove);
      this.coupon?.removeEventListener('pointerleave', this.onPointerLeave);
    }
  });
}
